import { toCodePointChar } from "#to-code-point-char";

/** Matches a leading variation selector code point. */
export const VARIATION_SELECTOR_REGEX = /^\p{Variation_Selector}/u;

/**
 * True if the first code point is a variation selector (VS1–VS16 and the ideographic VS
 * supplement): U+FE00–U+FE0F and U+E0100–U+E01EF.
 */
export function isVariationSelector(value: string | number): boolean {
  return VARIATION_SELECTOR_REGEX.test(toCodePointChar(value));
}
